$(document).ready(function(){
	// -- plan --
	$('svg .floor').on('mouseenter', function(){
		var floor = $(this).attr('data-floor');
		$('.floors li[data-floor="'+floor+'"]').addClass('active');
	});

	$('svg .floor').on('mouseleave', function(){
		$('.floors li').removeClass('active');
	});

	// -- plan fancybox event -- 
	$('svg .floor').on('click', function(){
		var floor = $(this).attr('data-floor');
		var relatedFloor = $('.floors li[data-floor="'+floor+'"] a');
		relatedFloor.first().trigger('click');
    return false;
	});

	// -- menu --
	$('.floors li').on('mouseenter', function(){
		var floor = $(this).attr('data-floor');
		$('svg .floor[data-floor="'+floor+'"]').addClass('active');
	});

	$('.floors li').on('mouseleave', function(){
		$('svg .floor').removeClass('active');
	});
});